/*------------------------------------------------------------------
Import styles
------------------------------------------------------------------*/

import './../styles/style.scss';

import { $, $$ } from './lib'
import inView from 'in-view';

/*------------------------------------------------------------------
Import external
------------------------------------------------------------------*/

document.addEventListener('DOMContentLoaded', () => {

    if ($('.slider-block,.js-animate-icon-block,.js-animate-person')) import('./animations');
    if ($('.js-slider-block')) import('./slider-block');
    if ($('.js-counter-block')) import('./counter-block');

    /*------------------------------------------------------------------
    Post Load classname removal
    ------------------------------------------------------------------*/

    $$('.js-postload').forEach(element => {
        element.classList.remove('js-postload');
    });


    /*------------------------------------------------------------------
    Animate elements when they come in to view
    ------------------------------------------------------------------*/

    inView('.js-in-view')
        .on('enter', el => { el.classList.add('inView') })


    /*------------------------------------------------------------------
    Animate hot spot elements when they come in to view
    ------------------------------------------------------------------*/

    inView('.js-in-out-view')
        .on('enter', el => { el.classList.add('inView') })
        .on('exit', el => { el.classList.remove('inView') })


    /*------------------------------------------------------------------
    Sticky header  
    ------------------------------------------------------------------*/

    let previousScrollPosition = 0;
    let scrollDelta = 22;
    let header = $('.header');
    let headerHeight = (header) ? header.clientHeight : 0;

    const stickyHeader = () => {
        let st = window.scrollY;
        if (Math.abs(previousScrollPosition - st) <= scrollDelta) return;
        if (st < 50) {
            header.classList.remove('nav-down');
            header.classList.remove('nav-up');
        } else if (st > previousScrollPosition && st > headerHeight) {
            header.classList.remove('nav-down');
            header.classList.add('nav-up');
        } else {
            if (st + window.innerHeight < document.body.clientHeight) {
                header.classList.add('nav-down');
                header.classList.remove('nav-up');
            }
        }
        previousScrollPosition = st;
    }

    window.addEventListener('scroll', stickyHeader);

});

